(() => {
  'use strict';
  const $ = id => document.getElementById(id);
  const catalog = JSON.parse($('palmHalloweenCatalog').textContent);
  const ui = JSON.parse($('palmHalloweenCopy').textContent);
  const labels = catalog.map(p => p.shortLabel);
  const exterior = $('exterior'), interior = $('interior'), stage = $('islandStage');
  const knockButton = $('knockButton'), door = $('doorHotspot'), dialog = $('ritualDialog');
  let entering = false, soundOn = false, audio, transitionTimer;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let motionOff = reduced.matches;
  function announce(text) { $('announcer').textContent = text; }
  function syncMotion() {
    document.body.classList.toggle('motion-off', motionOff);
    $('motionButton').setAttribute('aria-pressed', String(motionOff));
    $('motionButton').setAttribute('aria-label', motionOff ? ui.motionResume : ui.motionPause);
    $('motionButton').title = motionOff ? ui.motionPaused : ui.motionPause;
    $('motionButton').innerHTML = motionOff ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8 5 11 7-11 7z"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5v14M15 5v14"/></svg>';
  }
  syncMotion();
  $('motionButton').addEventListener('click', () => { motionOff = !motionOff; syncMotion(); });
  reduced.addEventListener('change', e => { motionOff = e.matches; syncMotion(); });
  function tone(kind) {
    if (!soundOn || !audio) return;
    const now = audio.currentTime;
    if (kind === 'knock') {
      const osc = audio.createOscillator(), gain = audio.createGain();
      osc.type = 'triangle'; osc.frequency.setValueAtTime(170, now); osc.frequency.exponentialRampToValueAtTime(55, now + .11);
      gain.gain.setValueAtTime(.001, now); gain.gain.exponentialRampToValueAtTime(.13, now + .006); gain.gain.exponentialRampToValueAtTime(.001, now + .15);
      osc.connect(gain).connect(audio.destination); osc.start(now); osc.stop(now + .18);
    } else {
      [523.25, 659.25, 783.99].forEach((f, i) => { const o = audio.createOscillator(), g = audio.createGain(), t = now + i * .12; o.type = 'sine'; o.frequency.value = f; g.gain.setValueAtTime(.001, t); g.gain.exponentialRampToValueAtTime(.035, t + .02); g.gain.exponentialRampToValueAtTime(.001, t + .6); o.connect(g).connect(audio.destination); o.start(t); o.stop(t + .65); });
    }
  }
  $('soundButton').addEventListener('click', async () => {
    try {
      if (!audio) audio = new (window.AudioContext || window.webkitAudioContext)();
      await audio.resume(); soundOn = !soundOn;
      $('soundButton').setAttribute('aria-pressed', String(soundOn));
      $('soundButton').setAttribute('aria-label', soundOn ? ui.soundOff : ui.soundOn);
      $('soundButton').title = soundOn ? ui.soundOnTitle : ui.soundOffTitle;
      $('soundButton').innerHTML = soundOn ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5 5 9H2v6h3l6 4zM16 8a6 6 0 0 1 0 8M19 5a10 10 0 0 1 0 14"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5 5 9H2v6h3l6 4zM16 9l5 6m0-6-5 6"/></svg>';
      if (soundOn) tone('knock');
    } catch { announce(ui.soundUnavailable); }
  });
  let seed = 71;
  function random() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
  for (let i = 0; i < 56; i++) { const s = document.createElement('i'); s.className = 'star'; s.style.cssText = `--x:${random()*100}%;--y:${random()*94}%;--size:${1+random()*1.5}px;--duration:${2+random()*5}s;--delay:${-random()*8}s`; $('stars').append(s); }
  exterior.addEventListener('pointermove', e => {
    if (motionOff || entering || e.pointerType === 'touch') return;
    const x = (e.clientX / window.innerWidth - .5), y = (e.clientY / window.innerHeight - .5);
    $('islandDepth').style.setProperty('--ry', (x * 5) + 'deg'); $('islandDepth').style.setProperty('--rx', (-y * 3) + 'deg');
  });
  exterior.addEventListener('pointerleave', () => { $('islandDepth').style.setProperty('--ry', '0deg'); $('islandDepth').style.setProperty('--rx', '0deg'); });
  function knock() {
    if (entering || exterior.hidden) return;
    tone('knock');
    stage.classList.remove('is-knocking'); void stage.offsetWidth; stage.classList.add('is-knocking');
    document.querySelectorAll('.knock-progress i').forEach(dot => dot.classList.add('is-done'));
    $('knockLabel').textContent = ui.comeIn;
    $('knockHint').textContent = ui.welcomeHint;
    announce(ui.opening);
    enter();
  }
  function enter() {
    entering = true; knockButton.disabled = true; door.disabled = true; stage.classList.add('is-opening'); tone('magic');
    transitionTimer = setTimeout(() => {
      exterior.classList.add('is-entering');
      transitionTimer = setTimeout(() => {
        exterior.hidden = true; interior.hidden = false; document.body.classList.add('inside');
        $('invitation').focus({ preventScroll: true }); entering = false;
      }, motionOff ? 80 : 1000);
    }, motionOff ? 80 : 550);
  }
  knockButton.addEventListener('click', knock); door.addEventListener('click', knock);
  $('backButton').addEventListener('click', () => {
    clearTimeout(transitionTimer); entering = false; interior.hidden = true; exterior.hidden = false;
    document.body.classList.remove('inside'); exterior.classList.remove('is-entering'); stage.classList.remove('is-opening','is-knocking');
    knockButton.disabled = false; door.disabled = false; $('knockLabel').textContent = ui.knock; $('knockHint').textContent = ui.knockHint;
    document.querySelectorAll('.knock-progress i').forEach(dot => dot.classList.remove('is-done')); knockButton.focus({ preventScroll: true }); announce(ui.back);
  });
  function selectProduct(index, animate = true) {
    const p = catalog[index]; if (!p) return;
    const image = $('productImage');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.hidden = !p.image;
    if (p.image) image.src = p.image;
    else image.removeAttribute('src');
    image.alt = p.name;
    $('productNumber').textContent = `${String(index+1).padStart(2,'0')} / ${String(catalog.length).padStart(2,'0')}`; $('productRitual').textContent = p.ritual.toUpperCase();
    $('productHeading').textContent = p.label; $('productName').textContent = p.name; $('productDescription').textContent = p.description; $('productIngredients').textContent = p.ingredients;
    for (const id of ['productNoteLabel', 'productLinkLabel']) {
      const label = $(id);
      if (label) label.textContent = p.isCombo ? label.dataset.comboLabel : label.dataset.barLabel;
    }
    const offer = $('productOffer');
    if (offer) {
      const offerTemplate = p.isCombo ? $('comboOffer-' + p.key) : null;
      if (offerTemplate) offer.replaceChildren(offerTemplate.content.cloneNode(true));
      else offer.replaceChildren();
      offer.hidden = !offerTemplate;
    }
    $('productLink').href = p.url; $('productLink').setAttribute('aria-label', ui.exploreProduct.replace('[product]', p.name));
    document.querySelectorAll('.ritual-choice').forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    if (animate) { $('productDetail').classList.remove('detail-refresh'); void $('productDetail').offsetWidth; $('productDetail').classList.add('detail-refresh'); }
  }
  document.querySelectorAll('.ritual-choice').forEach((button, index) => { button.addEventListener('click', () => selectProduct(index)); });
  selectProduct(0, false);
  function explore() { if (!dialog.open) { dialog.showModal(); document.body.style.overflow = 'hidden'; tone('magic'); } }
  $('invitation').addEventListener('click', explore);
  document.querySelectorAll('[data-explore]').forEach(button => button.addEventListener('click', explore));
  $('closeDialog').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { document.body.style.overflow = ''; });
  const image = $('islandArt');
  function loaded() { $('loadingIndicator').hidden = true; }
  if (image.complete && image.naturalWidth) loaded(); else { image.addEventListener('load', loaded, {once:true}); image.addEventListener('error', () => { $('loadingIndicator').textContent = ui.artUnavailable; }, {once:true}); }
  document.addEventListener('visibilitychange', () => { if(document.hidden && audio?.state === 'running') audio.suspend().catch(()=>{}); else if(!document.hidden && soundOn && audio?.state === 'suspended') audio.resume().catch(()=>{}); });
})();
